/**
 * The links a seeker copies or shares (2026-10-31). The app is a static site:
 * a chat app's link unfurler never runs its JS, so an app URL only ever shows
 * the site-wide card. Shared links go to the server's preview routes, which
 * carry their own Open Graph tags and then send a person on to the app:
 * /s/<short> for a reading, /c/<short>/ for a community candidate (a gift's
 * /g/<code> comes made from the server, care-package/link/prepare/).
 *
 * The host: the share host (VUE_APP_DJANGO_SHARE_URL), else the API host.
 * Django answers both. Never the page's own origin.
 * urls: { shareApiUrl, apiUrl } (static_store).
 */
export function shareHost (urls = {}) {
  return ((urls && (urls.shareApiUrl || urls.apiUrl)) || '').replace(/\/+$/, '')
}

export function readingShareUrl (short, urls) {
  return `${shareHost(urls)}/s/${short}`
}

export function candidateShareUrl (short, urls) {
  return `${shareHost(urls)}/c/${short}/`
}
